module.exports = __webpack_public_path__ + "static/scott_bitmoji-62f60fb77c5cd68028c567775e864c71.png";